// @ts-nocheck

const categoryDictionary = {
  genero: 'gender',
  piel: 'skin',
  cabello: 'hair',
  barba: 'beard',
  medias: 'socks',
  sombrero: 'acc',
  gafas: 'acc',
  guantes: 'acc',
}

export function customDataset(name: string) {
  const properties = name.replace('.png', '').split('_').filter(item => !item.includes('p-'))
  const dataType = properties[1].split('-')[0]
  let dataValue = ''
  let dataActive = false

  switch (dataType) {
    case 'genero':
      dataValue = properties[2] && properties[2].charAt(0).toUpperCase() + properties[2].slice(1)
      dataActive = dataValue.toLowerCase() === window.avatar.jsonAvatar.genero.toLowerCase()
      break;
    case 'piel':
      dataValue = properties[2]
      dataActive = dataValue === window.avatar.jsonAvatar.piel
      break;
    case 'cabello':
      dataValue = properties[1].split('-')[2];
      dataActive = dataValue === window.avatar.jsonAvatar.cabello.type
      break;
    case 'barba':
      dataValue = properties.length === 3 ? properties[2] : properties[1].split('-')[1];
      dataActive = dataValue === window.avatar.jsonAvatar.barba.type
      break;
    case 'medias':
      dataValue = properties.join('_')
      dataActive = properties[2] === window.avatar.jsonAvatar.medias.code
      break;
    case 'guantes':
    case 'sombrero':
      dataValue = properties.join('_')
      const acc = window.avatar.jsonAvatar[properties[0]].find(obj => obj.type === properties[1])
      dataActive = acc ? properties[2] === acc.code : false
      break;
    case 'gafas':
      dataValue = properties.join('_')
      dataActive = Boolean(window.avatar.jsonAvatar[properties[0]].find(obj => obj.type === properties[1]))
      break;
    default:
      dataValue = properties.join('_')
      dataActive = properties[1] === window.avatar.jsonAvatar[properties[0]].type && properties[2] === window.avatar.jsonAvatar[properties[0]].code      
  }

  return {
    "data-t": `${categoryDictionary[dataType] ? categoryDictionary[dataType] : 'item'}`,
    "data-v": `${dataValue}`,
    dataA: `${dataActive}`,
  }
}
